import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y border-pf-creamDark bg-pf-cream px-3 py-3 sm:px-4 sm:py-4" data-id="element-218" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-4xl" data-id="element-219" data-mp="3fy2ytulpdq2z">
        <div className="mb-1.5 text-center" data-id="element-220" data-mp="3b0kn5wgawwra">
          <h2 className="font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-221" data-mp="3azt2hgo8sjfs">
            What Coaches Are Saying
          </h2>
          <p className="font-display text-[10.5px] font-bold uppercase tracking-wide text-pf-coral sm:text-sm" data-id="element-222" data-mp="32063f1izjppw">
            ⭐⭐⭐⭐⭐ Verified Customer Reviews
          </p>
        </div>
        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-223" data-mp="2s1q9kqskq2cp">
          {testimonials.map(testimonial => <article key={testimonial.author} className="flex flex-col rounded-lg border border-pf-creamDark bg-white p-2.5 shadow-sm sm:p-3" data-id="element-224" data-mp="v96jpyljjtix">
              <div className="mb-1 flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-225" data-mp="h5y6q955730z">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-pf-gold text-pf-gold" aria-hidden="true" data-id="element-226" data-mp="m5b2xkhwlmg8" />)}
              </div>
              <p className="mb-1.5 text-[12px] font-medium italic leading-snug text-pf-ink sm:text-sm" data-id="element-227" data-mp="c7dhf4rfi3rb">
                “{testimonial.text}”
              </p>
              <div className="mt-auto flex items-center gap-2 border-t border-pf-creamDark pt-1.5" data-id="element-228" data-mp="14w2b4iq5n6t1">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-pf-navy font-display text-[13px] font-bold text-pf-gold" data-id="element-229" data-mp="q766kvnb4bx6">
                  {testimonial.author.charAt(0)}
                </span>
                <div className="leading-tight" data-id="element-230" data-mp="1iuihg8k3uvan">
                  <p className="font-display text-[12.5px] font-extrabold text-pf-navy" data-id="element-231" data-mp="1nm0isxq1ixw5">
                    {testimonial.author}
                  </p>
                  <p className="text-[10px] font-semibold uppercase tracking-wide text-pf-ink sm:text-[11px]" data-id="element-232" data-mp="1xgpnflj2x8ct">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}